module.exports = __webpack_public_path__ + "img/social-kktalk.286c6945.svg";